/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Table,
  Panel,
  Button,
} from 'react-bootstrap';
import subMonths from 'date-fns/sub_months';
import format from 'date-fns/format';
import addDays from 'date-fns/add_days';
import Toolbar from 'loracoms/Toolbar';
import PanelToolbar from 'loracoms/PanelToolbar';
import DatePicker from 'loracoms/DatePicker';
import RichLabel from 'loracoms/RichLabel';
import InlineSelect from 'loracoms/InlineSelect';
import Nvl from 'loracoms/Nvl';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const defaultFrom = () => subMonths(new Date(), 1);
const defaultTo = () => new Date();

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object.isRequired,
};

class Balogs extends React.Component {

  constructor(props) {
    super(props);
    this.from = defaultFrom();
    this.to = defaultTo();
    this.state = {
      plan: props.plan,
      balogs: [],
      filter: 'all',
      from: this.from,
      to: this.to,
    };
    this.handleSelectFrom = this.handleSelectFrom.bind(this);
    this.handleSelectTo = this.handleSelectTo.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'billing.balogs');
  }

  componentDidMount() {
    this.loadBalogs();
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  handleSelectFrom(from) {
    this.setState({ from });
    this.from = from;
    this.loadBalogs();
  }

  handleSelectTo(to) {
    this.setState({ to });
    this.to = to;
    this.loadBalogs();
  }

  loadBalogs() {
    let [from, to] = [this.from, this.to];
    from = format(from, 'YYYYMMDD');
    to = format(addDays(to, 1), 'YYYYMMDD');
    callAPI({
      endpoint: '/accounting/balogs',
      query: {
        df: from,
        dt: to,
        pageSize: 1000,
      },
    }).then((data) => {
      let balogs = data.list;
      balogs = _.sortBy(balogs, b => -new Date(b.time).valueOf());
      balogs = _.map(balogs, b => ({
        ...b,
        time: format(b.time, 'YYYY-MM-DD HH:mm:ss'),
      }));
      this.setState({ balogs });
    }).catch(() => {});
  }

  renderBalance() {
    const { pushState } = this.props;
    const { plan: { data: { balance } = {}, status } } = this.state;

    return (
      <div className={styles.balance}>
        <span className={styles.label}>{ this.intlMsg.msg('balance.lbl') }:</span>
        {' '}
        <Nvl val={balance} status={status} />
        {' '}
        <span className={styles.label}>{ this.intlMsg.msg('balance.unit') }</span>
        {' '}
        <span className={styles.recharge}>
          <Button
            bsStyle="aisz-primary"
            onClick={() => pushState('/billing/recharge')}
          >
            {this.intlMsg.msg('balance.recharge.btn')}
          </Button>
        </span>
      </div>
    );
  }

  renderBalogs() {
    const { filter = 'all', from = defaultFrom(), to = defaultTo() } = this.state;
    let { balogs } = this.state;

    balogs = _.filter(balogs, (b) => {
      switch (filter) {
        case 'all':
          return true;
        case 'recharge':
          return b.amount > 0;
        default:
          return b.amount <= 0;
      }
    });

    const rows = balogs.map((b) => {
      let t = null;
      if (b.amount > 0) {
        t = 'recharge';
      } else {
        t = 'expense';
      }
      return (
        <tr key={b.id}>
          <td>
            <RichLabel
              content={t}
              translateMap={{
                recharge: this.intlMsg.msg('types.recharge'),
                expense: this.intlMsg.msg('types.expense'),
              }}
            />
          </td>
          <td>{b.time}</td>
          <td>{b.amount}</td>
          <td>{b.snapshot}</td>
          <td />
          <td>{b.cause}</td>
        </tr>
      );
    });

    const fromDatePicker = (
      <DatePicker date={from} onSelect={this.handleSelectFrom} />
    );
    const toDatePicker = (
      <DatePicker date={to} onSelect={this.handleSelectTo} />
    );
    const filters = (
      <InlineSelect
        options={[{
          label: this.intlMsg.msg('types.options.all'),
          value: 'all',
          active: true,
        }, {
          label: this.intlMsg.msg('types.options.recharge'),
          value: 'recharge',
        }, {
          label: this.intlMsg.msg('types.options.expense'),
          value: 'expense',
        }]}
        values={[filter]}
        onChange={values => this.setState({ filter: values[0] })}
      />
    );

    return (
      <div className={styles.balogs}>
        <PanelToolbar tools={[fromDatePicker, toDatePicker, filters]} />
        <Table
          className="aisz-table-light"
          bordered
          striped
          hover
          responsive
        >
          <thead>
            <tr>
              <th>{ this.intlMsg.msg('table.header.type') }</th>
              <th>{ this.intlMsg.msg('table.header.time') }</th>
              <th>{ this.intlMsg.msg('table.header.amount') }</th>
              <th>{ this.intlMsg.msg('table.header.balance') }</th>
              <th>{ this.intlMsg.msg('table.header.ref') }</th>
              <th>{ this.intlMsg.msg('table.header.remark') }</th>
            </tr>
          </thead>
          <tbody>
            { rows }
          </tbody>
        </Table>
      </div>
    );
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
      onClick: () => this.props.pushState('/billing'),
    }, {
      content: this.intlMsg.msg('balogs', 'billing.breadcrumb'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div>
          {this.renderToolbar()}
        </div>
        <div>
          <Panel bsStyle="aisz-white">
            {this.renderBalance()}
            {this.renderBalogs()}
          </Panel>
        </div>
      </div>
    );
  }
}

Balogs.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
});
const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Balogs));




// WEBPACK FOOTER //
// ./src/containers/Billing/Balogs/index.jsx